import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
//Servicios
import { AdjuntoService } from 'src/app/services/adjunto.service';
//Modelos
import { Panel } from 'src/app/models/panel.model';
import { Requeridos } from 'src/app/models/requeridos.model';
import { ArchivoCrm } from 'src/app/models/archivocrm.model';
import { OptionSet } from 'src/app/models/optionSet.model';
import * as moment from 'moment';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { FaseService } from 'src/app/services/fase.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ProcesosActivosService } from 'src/app/services/procesosactivos.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ContactService } from 'src/app/services/contact.service';
import { UnificadoService } from 'src/app/services/unificado.service';
import { GeneralesService } from 'src/app/services/generales.service';

declare var $: any;

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css']
})
export class DocumentosComponent implements OnInit, OnDestroy, OnChanges {
  inforamar = false;
  titulo: string = 'Validando documentos requeridos';
  body: string = 'Esperar la validacion.';
  load = false;
  //Servicios
  lista: Requeridos; // Servicio Externo
  DocusCRM: ArchivoCrm = new ArchivoCrm(); // Servicio de CRM
  DocumentForm: FormGroup;
  @Input() IdProceso: string = ""; //id del preceso de matricula
  @Input() changeDocumentosCount: number = 0;
  @Output() Fase: EventEmitter<string> = new EventEmitter(); // avanzar la fase en el ribbon de fase
  @Output() CambiarCarrera: EventEmitter<void> = new EventEmitter();
  @Output() GoToMatricula: EventEmitter<void> = new EventEmitter();
  @Input() Panel: Panel = new Panel();
  @Input() CuartoMedio: boolean = false;
  @Input() faseActual: string;
  @Input() ultimafase: number;
  @Input() MayorEdad: boolean;

  DocumentosSubcribe: Subscription;
  DocumentosRequeridos = true;
  progress = false;
  sending = false;
  datosCargados = false;
  _validFileExtensions = ['image/jpg', 'image/jpeg', 'image/bmp', 'image/gif', 'image/png', 'application/pdf'];
  file1: File;
  file2: File;
  file3: File;
  file4: File;
  file5: File;
  file6: File;
  file7: File;
  file8: File;
  file9: File;
  file10: File;
  file11: File;
  file12: File;
  file13: File;
  file14: File;
  file15: File;
  file16: File;

  nfile1: string = '';
  nfile2: string = '';
  nfile3: string = '';
  nfile4: string = '';
  nfile5: string = '';
  nfile6: string = '';
  nfile7: string = '';
  nfile8: string = '';
  nfile9: string = '';
  nfile10: string = '';
  nfile11: string = '';
  nfile12: string = '';
  nfile13: string = '';
  nfile14: string = '';
  nfile15: string = '';
  nfile16: string = '';

  Pfile1 = false;
  Pfile2 = false;
  Pfile3 = false;
  Pfile4 = false;
  Pfile5 = false;
  Pfile6 = false;
  Pfile7 = false;
  Pfile8 = false;
  Pfile9 = false;
  Pfile10 = false;
  Pfile11 = false;
  Pfile12 = false;
  Pfile13 = false;
  Pfile14 = false;
  Pfile15 = false;
  Pfile16 = false;

  Pvalue1 = 0;
  Pvalue2 = 0;
  Pvalue3 = 0;
  Pvalue4 = 0;
  Pvalue5 = 0;
  Pvalue6 = 0;
  Pvalue7 = 0;
  Pvalue8 = 0;
  Pvalue9 = 0;
  Pvalue10 = 0;
  Pvalue11 = 0;
  Pvalue12 = 0;
  Pvalue13 = 0;
  Pvalue14 = 0;
  Pvalue15 = 0;
  Pvalue16 = 0;
  imagenTemp: any;
  constructor(
    private auths: AuthService,
    private contactservice: ContactService,
    private servicioUnificado: UnificadoService,
    private docService: AdjuntoService,
    private fb: FormBuilder,
    private procesoservice: ProcesoMatriculaService,
    private generalesService: GeneralesService,
    public faseService: FaseService,
    private alerts: ToastrService,
    private router: Router,
    private procesosActivosService: ProcesosActivosService
  ) {
    this.DocumentForm = fb.group({
      file01: [''],
      file02: [''],
      file03: [''],
      file04: [''],
      file05: [''],
      file06: [''],
      file07: [''],
      file08: [''],
      file09: [''],
      file10: [''],
      file11: [''],
      file12: [''],
      file13: [''],
      file14: [''],
      file15: [''],
      file16: ['']
    });
    this.DocumentosSubcribe = this.faseService.fase$.subscribe(value => {
      if (value == '4') {

        //Alerts
        this.inforamar = true;
        this.progress = true;
        this.alerts.info('Cargando documentos del Alumno', 'Fase  4 Documentos solicitados');

        docService.GetRequeridos(this.Panel.Institucion.Name, this.Panel.AnhoAcademico, this.Panel.TipoIngreso.Name == null ? 'PSU' : this.Panel.TipoIngreso.Name).subscribe(
          (data: Requeridos) => {
            this.load = true;
            if (data.data.length === 0) {
              this.DocumentosRequeridos = false
            }
            this.progress = false;
            this.titulo = 'Documentos Requeridos';
            if (data.status === 1) {

              document.getElementById("txtbody").innerHTML = `
              <br>
              <br> Para avanzar en el proceso de matrícula, se requiere que adjuntes la documentación que se menciona en el formulario. <br> Ten presentes las siguientes consideraciones antes de subir los documentos:<br>
              <br>
              <dd>
                  • Para algunas carreras del área o disciplinas de la Salud y Educación, se te solicitará documentación adicional,<br>&nbsp;&nbsp;para lo cual un asesor de matrícula tomará contacto contigo posterior a tu matrícula. Revisa los requisitos en
                  <a href="https://www.tupuedes.cl/">https://www.tupuedes.cl/</a><br> • Si no dispones de un documento que esté sin la indicación de obligatorio, podrás enviarlo posteriormente de acuerdo con la fecha indicada en el contrato que firmarás más adelante.<br>
                  <br>
              </dd>
              Si te falta algunos de los documentos, te recomendamos ingresar a los siguientes links: <br>
              <br>
              <dd>
                  • Licencia de Enseñanza Media: <a href="https://certificados.mineduc.cl/mvc/home/index">https://certificados.mineduc.cl/mvc/home/index</a><br> • Notas de Enseñanza Media: <a href="https://certificados.mineduc.cl/mvc/home/index">https://certificados.mineduc.cl/mvc/home/index</a><br>        • Certificado de Puntaje PDT/PAES:<a href="https://www.demre.cl">https://www.demre.cl</a><br> • Los documentos deben tener el formato PDF o JPG, tamaño máximo: 5 MB.
              </dd>
              `;
            }
            this.lista = data;
            this.docService.GetEstadoDocumentos(this.IdProceso).subscribe(
              (data: any) => {
                this.DocusCRM = data.Result;
                this.datosCargados = true;
                this.SetRequeridos();
              },
              (err) => {
                this.progress = false;
              }
            );
          },
          (err) => {
            this.titulo = 'Requisitos Disponibles';
            this.body = 'Se ha pedirdo la comunicacion con el servicio de validacion de documentos';
            this.progress = false;
          }
        );
      }
    });



  }
  ngOnDestroy(): void {
    this.DocumentosSubcribe.unsubscribe();
  }

  ngOnChanges(changes: any) {
    console.log('[DOCUMENTOS] ngOnChanges', changes)
    if (changes.changeDocumentosCount) {
      console.log(changes.changeDocumentosCount.currentValue);
      const _changeDocumentosCount = changes.changeDocumentosCount.currentValue;
      if (_changeDocumentosCount > 0) {
        console.log('[DOCUMENTOS] Cambiar documentos');
      }
    }
  }

  PermiteAdjuntar(EstadoDocto): boolean {
    if (!EstadoDocto)
      return true
    // case '4': result = 'Rechazado'
    // case '1': result = 'Aceptado'
    if (EstadoDocto.Value === '1')
      return false
    return true;
  }

  //Funcionalidad no contemplada
  Descargar(idFile: string) {
    this.alerts.info('Click ' + idFile, 'Descargando');
  }

  ngOnInit(): void {
    // This is intentional
  }

  Sfile1(archivo: File) {
    console.log(archivo.size);
    if (!archivo) {
      this.file1 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file1 = archivo;
  }
  Sfile2(archivo: File) {
    if (!archivo) {
      this.file2 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file2 = archivo;
  }
  Sfile3(archivo: File) {
    if (!archivo) {
      this.file3 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file3 = archivo;
  }
  Sfile4(archivo: File) {
    if (!archivo) {
      this.file4 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file4 = archivo;
  }
  Sfile5(archivo: File) {
    if (!archivo) {
      this.file5 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file5 = archivo;
  }
  Sfile6(archivo: File) {
    if (!archivo) {
      this.file6 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file6 = archivo;
  }
  Sfile7(archivo: File) {
    if (!archivo) {
      this.file7 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file7 = archivo;
  }
  Sfile8(archivo: File) {
    if (!archivo) {
      this.file8 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file8 = archivo;
  }
  Sfile9(archivo: File) {
    if (!archivo) {
      this.file9 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file9 = archivo;
  }
  Sfile10(archivo: File) {
    if (!archivo) {
      this.file10 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file10 = archivo;

  }
  Sfile11(archivo: File) {
    if (!archivo) {
      this.file11 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file11 = archivo;
  }
  Sfile12(archivo: File) {
    if (!archivo) {
      this.file12 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file12 = archivo;
  }
  Sfile13(archivo: File) {
    if (!archivo) {
      this.file13 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file13 = archivo;
  }
  Sfile14(archivo: File) {
    if (!archivo) {
      this.file14 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file14 = archivo;
  }
  Sfile15(archivo: File) {
    if (!archivo) {
      this.file15 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file15 = archivo;
  }
  Sfile16(archivo: File) {
    if (!archivo) {
      this.file16 = null;
      return;
    }
    if (this._validFileExtensions.indexOf(archivo.type) <= 0) {
      this.alerts.warning('Formato no valido ' + archivo.type);
      return;
    }
    if (archivo.size / 1024 / 1024 > 25) {
      this.alerts.warning('El Archivo ' + archivo.name + ' tamanho: ' + archivo.size, 'Excede el tamano maximo de 25mb', { positionClass: 'toast-top-full-width' });
      return;
    }
    this.file16 = archivo;
  }
  SetRequeridos() {
    this.DocusCRM.IdProceso = this.IdProceso;
    this.lista.data.forEach(element => {
      switch (element.codigoRequerimiento) {
        case 'RQA1':
          this.DocusCRM.Docto1 = true;
          this.nfile1 = element.nombreRequerimiento;
          if (element.obligatorio === 'S' || this.CuartoMedio) {
            this.DocusCRM.Docto1 = true;
            this.DocumentForm.controls.file01.setValidators(Validators.required);
            this.DocumentForm.controls.file01.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto1 = new OptionSet('6', '');
          }
          this.DocusCRM.Docto1 = true;
          if (this.DocusCRM.IdNota1 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file01.setValue(this.DocusCRM.IdNota1);
          }
          break;
        case 'RQA2':
          this.DocusCRM.Docto2 = true;
          this.nfile2 = element.nombreRequerimiento;
          if (this.CuartoMedio && !this.MayorEdad) {
            element.obligatorio = 'S';
          }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto2 = true;
            this.DocumentForm.controls.file02.setValidators(Validators.required);
            this.DocumentForm.controls.file02.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto2 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota2 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file02.setValue(this.DocusCRM.IdNota2);
          }
          break;
        case 'RQA3':
          this.DocusCRM.Docto3 = true;
          this.nfile3 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto3 = true;
            this.DocumentForm.controls.file03.setValidators(Validators.required);
            this.DocumentForm.controls.file03.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto3 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota3 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file03.setValue(this.DocusCRM.IdNota3);
          }
          break;
        case 'RQA4':
          this.DocusCRM.Docto4 = true;
          this.nfile4 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto4 = true;
            this.DocumentForm.controls.file04.setValidators(Validators.required);
            this.DocumentForm.controls.file04.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto4 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota4 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file04.setValue(this.DocusCRM.IdNota4);
          }
          break;
        case 'RQA5':
          this.DocusCRM.Docto5 = true;
          this.nfile5 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto5 = true;
            this.DocumentForm.controls.file05.setValidators(Validators.required);
            this.DocumentForm.controls.file05.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto5 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota5 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file05.setValue(this.DocusCRM.IdNota5);
          }
          break;
        case 'RQA6':
          this.DocusCRM.Docto6 = true;
          this.nfile6 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto6 = true;
            this.DocumentForm.controls.file06.setValidators(Validators.required);
            this.DocumentForm.controls.file06.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto6 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota6 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file06.setValue(this.DocusCRM.IdNota6);
          }
          break;
        case 'RQA7':
          this.DocusCRM.Docto7 = true;
          this.nfile7 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto7 = true;
            this.DocumentForm.controls.file07.setValidators(Validators.required);
            this.DocumentForm.controls.file07.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto7 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota7 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file07.setValue(this.DocusCRM.IdNota7);
          }
          break;
        case 'RQA8':
          this.DocusCRM.Docto8 = true;
          this.nfile8 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto8 = true;
            this.DocumentForm.controls.file08.setValidators(Validators.required);
            this.DocumentForm.controls.file08.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto8 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota8 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file08.setValue(this.DocusCRM.IdNota8);
          }
          break;
        case 'RQA9':
          this.DocusCRM.Docto9 = true;
          this.nfile9 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto9 = true;
            this.DocumentForm.controls.file09.setValidators(Validators.required);
            this.DocumentForm.controls.file09.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto9 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota9 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file09.setValue(this.DocusCRM.IdNota9);
          }
          break;
        case 'RQA10':
          this.DocusCRM.Docto10 = true;
          this.nfile10 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto10 = true;
            this.DocumentForm.controls.file10.setValidators(Validators.required);
            this.DocumentForm.controls.file10.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto10 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota10 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file10.setValue(this.DocusCRM.IdNota10);
          }
          break;
        case 'RQA11':
          this.DocusCRM.Docto11 = true;
          this.nfile11 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto11 = true;
            this.DocumentForm.controls.file11.setValidators(Validators.required);
            this.DocumentForm.controls.file11.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto11 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota11 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file11.setValue(this.DocusCRM.IdNota11);
          }
          break;
        case 'RQA12':
          this.DocusCRM.Docto12 = true;
          this.nfile12 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto12 = true;
            this.DocumentForm.controls.file12.setValidators(Validators.required);
            this.DocumentForm.controls.file12.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto12 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota12 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file12.setValue(this.DocusCRM.IdNota12);
          }
          break;
        case 'RQA13':
          this.DocusCRM.Docto13 = true;
          this.nfile13 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto13 = true;
            this.DocumentForm.controls.file13.setValidators(Validators.required);
            this.DocumentForm.controls.file13.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto13 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota13 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file13.setValue(this.DocusCRM.IdNota13);
          }
          break;
        case 'RQA14':
          this.DocusCRM.Docto14 = true;
          this.nfile14 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto14 = true;
            this.DocumentForm.controls.file14.setValidators(Validators.required);
            this.DocumentForm.controls.file14.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto14 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota14 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file14.setValue(this.DocusCRM.IdNota14);
          }
          break;
        case 'RQA15':
          this.DocusCRM.Docto15 = true;
          this.nfile15 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto15 = true;
            this.DocumentForm.controls.file15.setValidators(Validators.required);
            this.DocumentForm.controls.file15.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto15 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota15 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file15.setValue(this.DocusCRM.IdNota15);
          }
          break;
        case 'RQA16':
          this.DocusCRM.Docto16 = true;
          this.nfile16 = element.nombreRequerimiento;
          if (this.CuartoMedio) { element.obligatorio = 'N' }
          if (element.obligatorio === 'S') {
            this.DocusCRM.Docto16 = true;
            this.DocumentForm.controls.file16.setValidators(Validators.required);
            this.DocumentForm.controls.file16.updateValueAndValidity();
          } else {
            this.DocusCRM.EstadoDocto16 = new OptionSet('6', '');
          }
          if (this.DocusCRM.IdNota16 !== '00000000-0000-0000-0000-000000000000') {
            this.DocumentForm.controls.file16.setValue(this.DocusCRM.IdNota16);
          }
          break;
        default:
          break;
      }
    });
    if (this.DocumentForm.valid) {
      this.avanceFase();
    }
  }
  updateFaseDocumentos() {
    this.DocusCRM.IdProceso = this.IdProceso;
    this.docService.SetDocumentosRequeridos(this.DocusCRM).subscribe(
      (data) => { console.log(data) },
      (err) => { console.log(err) },
      () => { }
    );
  }

  handleStopAvance(msg: string = '', obj: any = null) {
    if (msg)
      console.log(`[DOCUMENTOS] ${msg}`, obj);
    this.progress = false;
    this.sending = false;
  }

  async comprobar_y_avanzar() {
    try {
      console.log('[DOCUMENTOS] this.DocumentForm.valid', this.DocumentForm.valid);
      if (this.DocumentForm.valid) {
        this.sending = true;
        /********* COMPROBACIONES PREVIAS *********/

        const user = this.auths.GetUserToken();
        if (!user) {
          return;
        }

        let opResult = true;

        const userData: any = await this.contactservice.GetContactFull(user.primarysid, this.IdProceso)
          .toPromise()
          .catch(err => {
            this.alerts.error('Ha ocurrido un error en el método GetContactFull');
            this.handleStopAvance('userData inner', err);
            opResult = false;
            return;
          });
        if (!opResult) {
          this.alerts.error('Ha ocurrido un error en el método GetContactFull');
          this.handleStopAvance('userData')
          return;
        }

        console.log('[DOCUMENTOS] userData', userData)


        // 1st Verificar bloqueo financiero
        const bloqueoFinanciero = false;//userData.BloqueoFinanciero;

        console.log('[DOCUMENTOS] bloqueoFinanciero', bloqueoFinanciero);

        // 1 => SI => Modal
      
          if (bloqueoFinanciero) {
            this.openModalBloqueoFinanciero();
            this.handleStopAvance();
            return;
          }
        

        // 1 => NO => 2nd Verificar bloqueo académico

          const resultBloqueoAcademico: any = await this.servicioUnificado.ObtieneSituacionAcademica({
            idProceso: this.IdProceso,
            Rut: userData.Rut,
          }).toPromise()
            .catch(err => {
              this.alerts.error('Ha ocurrido un error en el método ObtieneSituacionAcademica. Mensaje: ' + err);
              this.handleStopAvance('resultBloqueoAcademico inner', err)
              opResult = false;
              return;
            });
          if (!opResult || resultBloqueoAcademico.Codigo !== 1) {
            this.alerts.error('Ha ocurrido un error el método ObtieneSituacionAcademica.');
            this.handleStopAvance('resultBloqueoAcademico');
            return;
          }
          // const bloqueoAcademico: boolean = resultBloqueoAcademico.RetornoDesdeApi[0].Mensaje === "1|";
          const bloqueoAcademico: boolean = resultBloqueoAcademico.RetornoDesdeApi[0].Mensaje.startsWith("1|");
          console.log('[DOCUMENTOS] bloqueoAcademico', bloqueoAcademico);
          if (/*bloqueoAcademico*/false) {
            this.openModalBloqueoAcademico();
            this.handleStopAvance();
            return;
          }
        


        // 2 => Tiene bloqueo ("1|") => Modal con botones


        const panel: any = await this.generalesService.getPanel()
          .toPromise()
          .catch(err => {
            this.alerts.error('Ha ocurrido un error en método getPanel. Mensaje:' + err);
            this.handleStopAvance('panel inner', err)
            opResult = false;
            return;
          });
        if (!opResult) {
          this.alerts.error('Ha ocurrido un error en método getPanel.');
          this.handleStopAvance('panel');
          return;
        }

        console.log('[DOCUMENTOS] Comprobar y avanzar -> Panel', this.Panel)

        // Verificar cupos
        const payloadCupos = {
          codInstitucion: this.Panel.Institucion.Id,
          agnoAcademico: this.Panel.AnhoAcademico,
          semestreAcademico: this.Panel.SemestreAcademico,
          codSede: this.Panel.Sede.Id,
          codCarrera: this.Panel.Carrera.Id,
          jornada: this.Panel.Jornada.Value,
          codTipoIngreso: this.Panel.TipoIngreso == null ? 'PSU' : this.Panel.TipoIngreso.Name,
          viaAdmision: this.Panel.ViaAdmision,
        }
        const resultVerificacionCupos: any = await this.servicioUnificado.ObtieneCupos(payloadCupos).toPromise()
          .catch(err => {
            console.log(err);
            this.handleStopAvance('resultVerificacionCupos inner', err)
            opResult = false;
            return;
          });
        if (!opResult || resultVerificacionCupos.Codigo !== 1) {
          this.alerts.error('Ha ocurrido un error en método ObtieneCupos');
          this.handleStopAvance('resultVerificacionCupos')
          return;
        }
        const existenCupos: boolean = resultVerificacionCupos.CuposRestantes > 0;
        //const existenCupos: boolean = false;
        console.log('[DOCUMENTOS] existenCupos', existenCupos);

        if (!existenCupos) {
          this.openModalBloqueoVacantes();
          this.handleStopAvance();
          return;
        }
        /********* COMPROBACIONES PREVIAS *********/
        this.avanceFase();
      }
    } catch (error) {
      this.alerts.error('Ha ocurrido un error. Mensaje: ' + error);
      this.handleStopAvance('[DOCUMENTOS] catch comprobar y avanzar', error)
      this.progress = false;
    };
  }

  avanceFase() {
    try {
      if (this.DocumentForm.valid) {
        this.sending = true;
        if (this.ultimafase > 4) {
          this.sending = false;
          this.Fase.emit('5');
          this.faseService.fase$.emit('5');
          return;
        }
        this.procesoservice.setFase(this.IdProceso, '5').subscribe(
          (data) => {

            this.Fase.emit('5');
            this.faseService.fase$.emit('5');
            this.sending = false;
          },
          (err) => {
            this.alerts.error('Ha ocurrido un error en método Cambiar de fase. Contacte a un usuario de soporte de Santo Tomás');
            this.handleStopAvance(); console.log(err);
          },
          () => {
            this.handleStopAvance();
          },
        );
      }
    } catch (error) {
      this.alerts.error('Ha ocurrido un error en metodo avanceFase. Mensaje: ' + error);
      this.handleStopAvance('[DOCUMENTOS] catch avanceFase', error);
    }
  }
  SendFile1() {
    if (this.file1 === null || this.file1 == undefined) { return }
    this.Pfile1 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file1, this.nfile1).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue1 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file01.setValue(result.Id);
              this.DocusCRM.IdNota1 = result.Id;
              this.DocusCRM.FechaDocto1 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto1 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile1 = false;
        }
      }

    );
  }
  SendFile2() {
    if (this.file2 === null || this.file2 == undefined) { return }
    this.Pfile2 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file2, this.nfile2).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue2 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file02.setValue(result.Id);
              this.DocusCRM.IdNota2 = result.Id;
              this.DocusCRM.FechaDocto2 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto2 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile2 = false;
        }
      }

    );
  }
  SendFile3() {
    if (this.file3 === null || this.file3 == undefined) { return }
    this.Pfile3 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file3, this.nfile3).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue3 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file03.setValue(result.Id);
              this.DocusCRM.IdNota3 = result.Id;
              this.DocusCRM.FechaDocto3 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto3 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile3 = false;
        }
      }

    );
  }
  SendFile4() {
    if (this.file4 === null || this.file4 == undefined) { return }
    this.Pfile4 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file4, this.nfile4).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue4 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file04.setValue(result.Id);
              this.DocusCRM.IdNota4 = result.Id;
              this.DocusCRM.FechaDocto4 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto4 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile4 = false;
        }
      }

    );
  }
  SendFile5() {
    if (this.file5 === null || this.file5 == undefined) { return }
    this.Pfile5 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file5, this.nfile5).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue5 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file05.setValue(result.Id);
              this.DocusCRM.IdNota5 = result.Id;
              this.DocusCRM.FechaDocto5 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto5 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile5 = false;
        }
      }

    );
  }
  SendFile6() {
    if (this.file6 === null || this.file6 == undefined) { return }
    this.Pfile6 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file6, this.nfile6).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue6 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file06.setValue(result.Id);
              this.DocusCRM.IdNota6 = result.Id;
              this.DocusCRM.FechaDocto6 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto6 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile6 = false;
        }
      }

    );
  }
  SendFile7() {
    if (this.file7 === null || this.file7 == undefined) { return }
    this.Pfile7 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file7, this.nfile7).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue7 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file07.setValue(result.Id);
              this.DocusCRM.IdNota7 = result.Id;
              this.DocusCRM.FechaDocto7 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto7 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile7 = false;
        }
      }

    );
  }
  SendFile8() {
    if (this.file8 === null || this.file8 == undefined) { return }
    this.Pfile8 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file8, this.nfile8).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue8 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file08.setValue(result.Id);
              this.DocusCRM.IdNota8 = result.Id;
              this.DocusCRM.FechaDocto8 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto8 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile8 = false;
        }
      }

    );
  }
  SendFile9() {
    if (this.file9 === null || this.file9 == undefined) { return }
    this.Pfile9 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file9, this.nfile9).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue9 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file09.setValue(result.Id);
              this.DocusCRM.IdNota9 = result.Id;
              this.DocusCRM.FechaDocto9 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto9 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile9 = false;
        }
      }

    );
  }
  SendFile10() {
    if (this.file10 === null || this.file10 == undefined) { return }
    this.Pfile10 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file10, this.nfile10).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue10 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file10.setValue(result.Id);
              this.DocusCRM.IdNota10 = result.Id;
              this.DocusCRM.FechaDocto10 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto10 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile10 = false;
        }
      }

    );
  }
  SendFile11() {
    if (this.file11 === null || this.file11 == undefined) { return }
    this.Pfile11 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file11, this.nfile11).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue11 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file11.setValue(result.Id);
              this.DocusCRM.IdNota11 = result.Id;
              this.DocusCRM.FechaDocto11 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto11 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile11 = false;
        }
      }

    );
  }
  SendFile12() {
    if (this.file12 === null || this.file12 == undefined) { return }
    this.Pfile12 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file12, this.nfile12).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue12 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file12.setValue(result.Id);
              this.DocusCRM.IdNota12 = result.Id;
              this.DocusCRM.FechaDocto12 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto12 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile12 = false;
        }
      }
    );
  }
  SendFile13() {
    if (this.file13 === null || this.file13 == undefined) { return }
    this.Pfile13 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file13, this.nfile13).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue13 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file13.setValue(result.Id);
              this.DocusCRM.IdNota13 = result.Id;
              this.DocusCRM.FechaDocto13 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto13 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile13 = false;
        }
      }
    );
  }
  SendFile14() {
    if (this.file14 === null || this.file14 == undefined) { return }
    this.Pfile14 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file14, this.nfile14).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue14 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file14.setValue(result.Id);
              this.DocusCRM.IdNota14 = result.Id;
              this.DocusCRM.FechaDocto14 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto14 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile14 = false;
        }
      }
    );
  }
  SendFile15() {
    if (this.file15 === null || this.file15 == undefined) { return }
    this.Pfile15 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file15, this.nfile15).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue15 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file15.setValue(result.Id);
              this.DocusCRM.IdNota15 = result.Id;
              this.DocusCRM.FechaDocto15 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto15 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile15 = false;
        }
      }
    );
  }
  SendFile16() {
    if (this.file16 === null || this.file16 == undefined) { return }
    this.Pfile16 = true;
    this.docService.AdjuntarNota(this.IdProceso, this.file16, this.nfile16).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue16 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file16.setValue(result.Id);
              this.DocusCRM.IdNota16 = result.Id;
              this.DocusCRM.FechaDocto16 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto16 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile16 = false;
        }
      }
    );
  }
  UpdateFile1() {
    if (this.file1 === null) { return }
    this.Pfile1 = true;
    this.docService.UpdateNota(this.IdProceso, this.file1, this.nfile1, this.DocumentForm.controls.file01.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue1 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file01.setValue(result.Id);
              this.DocusCRM.IdNota1 = result.Id;
              this.DocusCRM.FechaDocto1 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto1 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile1 = false;
        }
      }

    );
  }

  UpdateFile2() {
    if (this.file2 === null) { return }
    this.Pfile2 = true;
    this.docService.UpdateNota(this.IdProceso, this.file2, this.nfile2, this.DocumentForm.controls.file02.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue2 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file02.setValue(result.Id);
              this.DocusCRM.IdNota2 = result.Id;
              this.DocusCRM.FechaDocto2 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto2 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile2 = false;
        }
      }

    );
  }
  UpdateFile3() {
    if (this.file3 === null) { return }
    this.Pfile3 = true;
    this.docService.UpdateNota(this.IdProceso, this.file3, this.nfile3, this.DocumentForm.controls.file03.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue3 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file03.setValue(result.Id);
              this.DocusCRM.IdNota3 = result.Id;
              this.DocusCRM.FechaDocto3 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto3 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile3 = false;
        }
      }

    );
  }
  UpdateFile4() {
    if (this.file4 === null) { return }
    this.Pfile4 = true;
    this.docService.UpdateNota(this.IdProceso, this.file4, this.nfile4, this.DocumentForm.controls.file04.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue4 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file04.setValue(result.Id);
              this.DocusCRM.IdNota4 = result.Id;
              this.DocusCRM.FechaDocto4 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto4 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile4 = false;
        }
      }

    );
  }
  UpdateFile5() {
    if (this.file5 === null) { return }
    this.Pfile5 = true;
    this.docService.UpdateNota(this.IdProceso, this.file5, this.nfile5, this.DocumentForm.controls.file05.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue5 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file05.setValue(result.Id);
              this.DocusCRM.IdNota5 = result.Id;
              this.DocusCRM.FechaDocto5 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto5 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile5 = false;
        }
      }

    );
  }
  UpdateFile6() {
    if (this.file6 === null) { return }
    this.Pfile6 = true;
    this.docService.UpdateNota(this.IdProceso, this.file6, this.nfile6, this.DocumentForm.controls.file06.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue6 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file06.setValue(result.Id);
              this.DocusCRM.IdNota6 = result.Id;
              this.DocusCRM.FechaDocto6 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto6 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile6 = false;
        }
      }

    );
  }
  UpdateFile7() {
    if (this.file7 === null) { return }
    this.Pfile7 = true;
    this.docService.UpdateNota(this.IdProceso, this.file7, this.nfile7, this.DocumentForm.controls.file07.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue7 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file07.setValue(result.Id);
              this.DocusCRM.IdNota7 = result.Id;
              this.DocusCRM.FechaDocto7 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto7 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile7 = false;
        }
      }

    );
  }
  UpdateFile8() {
    if (this.file8 === null) { return }
    this.Pfile8 = true;
    this.docService.UpdateNota(this.IdProceso, this.file8, this.nfile8, this.DocumentForm.controls.file08.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue8 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file08.setValue(result.Id);
              this.DocusCRM.IdNota8 = result.Id;
              this.DocusCRM.FechaDocto8 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto8 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile8 = false;
        }
      }

    );
  }
  UpdateFile9() {
    if (this.file9 === null) { return }
    this.Pfile9 = true;
    this.docService.UpdateNota(this.IdProceso, this.file9, this.nfile9, this.DocumentForm.controls.file09.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue9 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file09.setValue(result.Id);
              this.DocusCRM.IdNota9 = result.Id;
              this.DocusCRM.FechaDocto9 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto9 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile9 = false;
        }
      }

    );
  }
  UpdateFile10() {
    if (this.file10 === null) { return }
    this.Pfile10 = true;
    this.docService.UpdateNota(this.IdProceso, this.file10, this.nfile10, this.DocumentForm.controls.file10.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue10 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file10.setValue(result.Id);
              this.DocusCRM.IdNota10 = result.Id;
              this.DocusCRM.FechaDocto10 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto10 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile10 = false;
        }
      }

    );
  }
  UpdateFile11() {
    if (this.file11 === null) { return }
    this.Pfile11 = true;
    this.docService.UpdateNota(this.IdProceso, this.file11, this.nfile11, this.DocumentForm.controls.file11.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue11 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file11.setValue(result.Id);
              this.DocusCRM.IdNota11 = result.Id;
              this.DocusCRM.FechaDocto11 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto11 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile11 = false;
        }
      }

    );
  }
  UpdateFile12() {
    if (this.file12 === null) { return }
    this.Pfile12 = true;
    this.docService.UpdateNota(this.IdProceso, this.file12, this.nfile12, this.DocumentForm.controls.file12.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue12 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file12.setValue(result.Id);
              this.DocusCRM.IdNota12 = result.Id;
              this.DocusCRM.FechaDocto12 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto12 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile12 = false;
        }
      }
    );
  }
  UpdateFile13() {
    if (this.file13 === null) { return }
    this.Pfile13 = true;
    this.docService.UpdateNota(this.IdProceso, this.file13, this.nfile13, this.DocumentForm.controls.file13.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue13 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file13.setValue(result.Id);
              this.DocusCRM.IdNota13 = result.Id;
              this.DocusCRM.FechaDocto13 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto13 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile13 = false;
        }
      }
    );
  }
  UpdateFile14() {
    if (this.file14 === null) { return }
    this.Pfile14 = true;
    this.docService.UpdateNota(this.IdProceso, this.file14, this.nfile14, this.DocumentForm.controls.file14.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue14 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file14.setValue(result.Id);
              this.DocusCRM.IdNota14 = result.Id;
              this.DocusCRM.FechaDocto14 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto14 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile14 = false;
        }
      }
    );
  }
  UpdateFile15() {
    if (this.file15 === null) { return }
    this.Pfile15 = true;
    this.docService.UpdateNota(this.IdProceso, this.file15, this.nfile15, this.DocumentForm.controls.file15.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue15 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file15.setValue(result.Id);
              this.DocusCRM.IdNota15 = result.Id;
              this.DocusCRM.FechaDocto15 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto15 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile15 = false;
        }
      }
    );
  }
  UpdateFile16() {
    if (this.file16 === null) { return }
    this.Pfile16 = true;
    this.docService.UpdateNota(this.IdProceso, this.file16, this.nfile16, this.DocumentForm.controls.file16.value).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.Pvalue16 = Math.round(event.loaded / event.total) * 100;
        } else if (event.type === HttpEventType.Response) {
          if (event.status === 200) {
            var result = event.body["Result"];
            if (!result.Error) {
              this.DocumentForm.controls.file16.setValue(result.Id);
              this.DocusCRM.IdNota16 = result.Id;
              this.DocusCRM.FechaDocto16 = moment().format('YYYY-MM-DD');
              this.DocusCRM.EstadoDocto16 = new OptionSet('5', '', 'Adjuntado');
              this.updateFaseDocumentos();
            }
          }
          this.Pfile16 = false;
        }
      }
    );
  }

  /********* Modales *********/
  openModalBloqueoFinanciero() {
    $('#modalBloqueoFinanciero').modal('show');
  }

  openModalBloqueoAcademico() {
    $('#modalBloqueoAcademico').modal('show');
  }

  openModalBloqueoVacantes() {
    $('#modalVacantes').modal('show');
  }
  /********* Modales *********/

  /********* Operaciones de Modales *********/
  seleccionarOtraCarrera() {
    this.CambiarCarrera.emit();
    $('#modalBloqueoAcademico').modal('hide');
    $('#modalVacantes').modal('hide');
  }

  contactar() {
    console.log('[DOCUMENTOS] contactar')
    this.procesoservice.listaEspera(this.IdProceso)
      .toPromise()
      .catch(err => {
        this.alerts.error('Ocurrió un error, intente nuevamente', 'Atención');
        console.log(err);
      });
    $('#modalBloqueoAcademico').modal('hide');
    $('#modalVacantes').modal('hide');
  }

  cancelarPostulacion() {
    console.log('[DOCUMENTOS] cancelarPostulacion')
    this.procesoservice.desactivaSimulacion(this.IdProceso).subscribe(
      (data: any) => {
        this.alerts.success('Proceso cancelado');
        this.router.navigateByUrl('/inicio');
        this.procesosActivosService.procesosActivos$.emit('LOAD_PROCESOS');
      },
      (err) => {
        this.alerts.error('Ocurrió un error, intente nuevamente', 'Atención');
        console.log(err);
      },
      () => {
        $('#modalBloqueoAcademico').modal('hide');
        $('#modalVacantes').modal('hide');
      }
    )
  }
  /********* Operaciones de Modales *********/

  goToMatricula() {
    console.log('[DOCUMENTOS] Go to Matrícula')
    this.GoToMatricula.emit();
  }

  redirigirAlInicio() {
    this.router.navigateByUrl('/inicio');
  }

}
